export default "__VITE_ASSET__b61d326e__"